module.exports = __webpack_public_path__ + "static/media/hero-screenshot-1.1669eb96.png";